import React from "react";
// Import de l'image Ecovadis (assurez-vous qu'elle est dans assets)
import ecovadisImg from "../assets/ecovadis.png";

const StatsBar = () => {
  return (
    <div className="stats-bar-container">
      <div className="stat-item">
        <h3>9 M€</h3>
        <p>Chiffres d'affaires</p>
      </div>

      <div className="stat-item">
        {/* La Médaille */}
        <img src={ecovadisImg} alt="Ecovadis Gold" className="ecovadis-badge" />
      </div>

      <div className="stat-item">
        <h3>+12%</h3>
        <p>De croissance</p>
      </div>

      <div className="stat-item">
        {/* Icône bonhomme simple en texte, ou remplacez par une image */}
        <span style={{ fontSize: "2rem", display: "block" }}>👤</span>
        <h3>54</h3>
        <p>Collaborateurs</p>
      </div>
    </div>
  );
};

export default StatsBar;
